module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1200.954592e8.svg";